<!-- 打印证书 -->
<template>
  <div class="w1200">
    <el-card
      :visible="visible"
      v-loading="confirmLoading" element-loading-text="加载中"
      >
        <div>
          <el-select v-model="templateModel" placeholder="选择打印的证书模板类型" style="width: 200px;margin-right: 10px;" @change="templageModelChange">
            <el-option :value="1" label="竖版"></el-option>
            <!-- <el-option :value="2" label="横版"></el-option> -->
          </el-select>
          <el-button type="primary" icon="rollback" @click="back">返回</el-button>
          <el-button type="primary"  @click="downLoadPdf(htmlTitle, nowTime)">下载模板</el-button>
        </div>
        <div class="certificateBox">
          <div style="overflow:hidden; margin-top:20px;margin-bottom:30px; ">
             <!-- <div class="a4Div" :style="{backgroundImage:'url('+backgroundImg+')',backgroundSize:'100%', width: div4Width + 'px', height: div4Height + 'px'}"> -->
            <div class="a4Div" :style="{backgroundImage:'url('+backgroundImgDefult+')',backgroundSize:'100%', width: div4Width + 'px', height: div4Height + 'px'}">
             <!-- @mousedown="moveContent($event, item)" -->
              <img :src="initImg()" alt="" class="posiImg">
              <!-- <span>{{initImg()}}</span> -->
              <span
                v-for="item in this.certData"
                :key="item.name"
                v-show="item.show"
                :style="{top: item.positionTop + 'px', left: item.positionLeft + 'px', fontSize: item.fontSize + 'px', fontWeight: item.fontWeight,color:'#'+item.colorStr}">{{ item.value }}</span>
            </div>
            <div class="a4Option" style="display:none">
              <h1>功能选择</h1>
              <!--
              <font>上传背景图片：</font>
              <div style="border:1px solid red;width:178px;height:178px;position: relative;border: 1px dashed #d9d9d9;border-radius: 6px;"  v-loading="uploadLoading" element-loading-text="加载中">
                <i class="pdelete el-icon-delete" v-if="imageUrl" @click="removeImg"></i>
                <el-upload
                  class="avatar-uploader"
                  action="http://mechanism.daoba.com/manager/fileUpload"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="uploadBefore"
                  :on-error="uploadError"
                  >
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              -->
              <br/>
              <div v-for="(item, index) in this.certData" :key="item.name">
                <el-row :gutter="12" style="margin-bottom:10px;">
                  <el-col :span="4">
                    <font>{{ item.name }}：</font>
                  </el-col>
                  <el-col :span="!item.isCustom ? 6 : 6">
                    <!-- 如果是编号，不可隐藏 -->
                    <el-select :disabled="item.name === '编号' ? true : false" style="width: 100%" @change="showChange($event, item)" :value="item.show ? 1 : 2">
                      <el-option :value="1" label="显示"></el-option>
                      <el-option :value="2" label="不显示"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="!item.isCustom ? 5 : 6">
                    <el-select style="width: 100%" @change="fontSizeChange($event, item)" placeholder="选择字体大小" :value="item.fontSize">
                      <el-option :value="12" label="12"></el-option>
                      <el-option :value="14" label="14"></el-option>
                      <el-option :value="16" label="16"></el-option>
                      <el-option :value="18" label="18"></el-option>
                      <el-option :value="20" label="20"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="!item.isCustom ? 5 : 6">
                    <el-select style="width: 100%" @change="fontWeightChange($event, item)" placeholder="是否加粗" :value="item.fontWeight">
                      <el-option :value="'normal'" label="不加粗"></el-option>
                      <el-option :value="'bold'" label="加粗"></el-option>
                    </el-select>
                  </el-col>
                  <el-col v-if="!item.isCustom" :span="!item.isCustom ? 2 : 4">
                    <el-color-picker :value="getColor(item)" @change="changeColor($event, item)" color-format='hex'></el-color-picker>
                  </el-col>
                  <el-col v-if="item.isCustom" :span="4" :style="item.isCustom?'margin-top:10px;':''">
                    <span> &nbsp;</span>
                  </el-col>
                  <el-col v-if="item.isCustom" :span="6" :style="item.isCustom?'margin-top:10px;':''">
                    <el-input v-model="item.value"/>
                  </el-col>
                   <el-col v-if="item.isCustom" :span="!item.isCustom ? 2 : 4" :style="item.isCustom?'margin-top:10px;':''">
                    <el-color-picker :value="getColor(item)" color-format='hex'  @change="changeColor($event, item)"></el-color-picker>
                  </el-col>
                  <el-col v-if="item.isCustom" :span="2" :style="item.isCustom?'margin-top:10px;':''">
                    <a @click="del(index)">删除</a>
                  </el-col>
                </el-row>
              </div>
              <el-row :gutter="12" style="width: 640px;">
                <el-col :span="6">
                  <el-button type="dashed" style="width: 100%;" @click="addPrintData">添加证书内容</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" style="width: 100%;" @click="saveTemplateFun()">保存模板格式</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" style="width: 100%;" @click="downLoadPdf(htmlTitle, nowTime)">下载模板</el-button>
                </el-col>
              </el-row>
            </div>

          </div>
        </div>

    </el-card>
    <add-print-cert-data ref="addPrintCertData"  @addPrintDataSuccess="addPrintDataSuccess(arguments)"></add-print-cert-data>
  </div>
</template>
<script>
// import  from './modules/AddPrintCertData'
import AddPrintCertData from '@/components/common/UserCenter/AddPrintCertData'
// import certificateUserService from '@/api/certificateService/certificateUser'
import { findById, saveTemplate } from '@/api/association'
import {formatDate} from '@/components/common/config/formatTime.js'
// import certificateTemplateService from '@/api/certificateService/certificateTemplate'
export default {
  components: {
    AddPrintCertData
  },
  data () {
    return {
      color: '#000',
      imageUrl: '',
      dialogVisible: false,
      disabled: false,
      title: '打印证书',
      value: '',
      options: [{
        value: '1',
        label: '竖版'
      }, {
        value: '2',
        label: '横版'
      }],
      visible: false,
      confirmLoading: false,
      uploadLoading: false,
      imgurl: process.env.VUE_APP_API_BASE_URL + '/fileUpload',
      fileLogo: [],
      templateModel: 1,
      backgroundImg: '',
      backgroundImgDefult: 'static/images/refercert-bg.jpg',
      rowData: JSON.parse(this.$route.query.row), // 证书用户id
      certData: [

      ], // 证书元素内容
      basePositionTop: 40, // 证书内容的基础上边距
      basePositionLeft: 200, // 证书内容的基础左边距
      baseFontSize: 12, // 证书内容的基础字体大小
      baseFontWeight: 'normal', // 证书内容的基础字体
      htmlTitle: '', // 网页标题
      div4Width: 580, // 打印区域宽度
      div4Height: 820, // 打印区域高度
      nowTime: '', // 当前时间
      printData: {}, // 要打印的内容
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo'))
    }
  },
  mounted () {
    this.queryPrintData()
    console.log(this.rowData)
  },
  methods: {
    formatDate,
    getAnalysisIdCard (card, num) {
      if (num === 1) {
      // 获取出生日期
        let birth = card.substring(6, 10) + '-' + card.substring(10, 12) + '-' + card.substring(12, 14)
        return birth
      }
      if (num === 2) {
      // 获取性别
        if (parseInt(card.substr(16, 1)) % 2 === 1) {
        // 男
          return '男'
        } else {
        // 女
          return '女'
        }
      }
      if (num === 3) {
      // 获取年龄
        var myDate = new Date()
        var month = myDate.getMonth() + 1
        var day = myDate.getDate()
        var age = myDate.getFullYear() - card.substring(6, 10) - 1
        if ((card.substring(10, 12) < month || card.substring(10, 12) === month) && card.substring(12, 14) <= day) {
          age++
        }
        return age
      }
    },
    // 获取要打印的内容
    queryPrintData () {
      let str = this.rowData.getDate
      let str1 = str.substring(0, str.indexOf(' '))
      this.certData.push(this.getDiv4Content('姓名', this.rowData.userName, false, this.certData))
      this.certData.push(this.getDiv4Content('编号', this.rowData.certNo, false, this.certData))
      this.certData.push(this.getDiv4Content('性别', this.rowData.sex === 1 ? '男' : '女', false, this.certData))
      this.certData.push(this.getDiv4Content('等级', this.rowData.typeName, false, this.certData))
      this.certData.push(this.getDiv4Content('发证日期', this.initTime(str1), false, this.certData))
      this.certData.push(this.getDiv4Content('出生日期', formatDate(this.rowData.birthday), false, this.certData))
      // this.certData.push(this.getDiv4Content('', this.rowData.colorStr, false, this.certData))
      // 打印信息查询完毕获取打印模板信息
      // this.queryTemplate(this.rowData.certId)
    },
    /**
     * 生成证书内的内容
     * @param name 内容名称
     * @param value 内容信息
     * @param isCustom  是否是自定义内容，自定义内容可以修改，true：是 false：不是
     */
    getDiv4Content (name, value, isCustom, ary) {
      let positionTop, positionLeft, show
      if (name === '姓名') {
        positionTop = 440
        positionLeft = 160
        show = true
      } else if (name === '编号') {
        positionTop = 415
        positionLeft = 160
        show = true
      } else if (name === '出生日期') {
        positionTop = 466
        positionLeft = 160
        show = true
      } else if (name === '发证日期') {
        positionTop = 586
        positionLeft = 280
        show = true
      } else {
        show = false
      }

      const obj = {
        name: name,
        value: value,
        // 每个元素距离顶部的距离递增30
        // positionTop: this.basePositionTop + 30 * ary.length,
        // positionLeft: this.basePositionLeft,
        positionTop: positionTop,
        positionLeft: positionLeft,
        fontSize: 14,
        fontWeight: 600,
        show: show,
        isCustom: isCustom,
        colorStr: '#000'
      }
      return obj
    },
    initTime (str1) {
      let dataArr = str1.split('-')
      let month = dataArr[1]
      let momthEn = ''
      if (month === '01') {
        momthEn = 'January'
      } else if (month === '02') {
        momthEn = 'February'
      } else if (month === '03') {
        momthEn = 'March'
      } else if (month === '04') {
        momthEn = 'April'
      } else if (month === '05') {
        momthEn = 'May'
      } else if (month === '06') {
        momthEn = 'June'
      } else if (month === '07') {
        momthEn = 'July'
      } else if (month === '08') {
        momthEn = 'August'
      } else if (month === '09') {
        momthEn = 'September'
      } else if (month === '10') {
        momthEn = 'October'
      } else if (month === '11') {
        momthEn = 'November'
      } else if (month === '12') {
        momthEn = 'December'
      }
      return dataArr[2] + ' ' + momthEn + ', ' + dataArr[0]
    },
    initImg () {
      let imgUrl = ''
      if (this.rowData.typeName === '一级') {
        imgUrl = 'static/images/level-01.png'
      } else if (this.rowData.typeName === '二级') {
        imgUrl = 'static/images/level-02.png'
      } else if (this.rowData.typeName === '三级') {
        imgUrl = 'static/images/level-03.png'
      } else if (this.rowData.typeName === '四级') {
        imgUrl = 'static/images/level-04.png'
      } else if (this.rowData.typeName === '五级') {
        imgUrl = 'static/images/level-05.png'
      } else if (this.rowData.typeName === '六级') {
        imgUrl = 'static/images/level-06.png'
      } else if (this.rowData.typeName === '七级') {
        imgUrl = 'static/images/level-07.png'
      } else if (this.rowData.typeName === '八级') {
        imgUrl = 'static/images/level-08.png'
      } else if (this.rowData.typeName === '九级') {
        imgUrl = 'static/images/level-09.png'
      } else {
        imgUrl = ''
      }
      return imgUrl
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleAvatarSuccess (res, file) {
      this.uploadLoading = false
      this.imageUrl = URL.createObjectURL(file.raw)
      this.backgroundImg = this.imageUrl
    },
    uploadBefore () {
      this.uploadLoading = true
    },
    uploadError () {
      this.uploadLoading = false
      this.$message.error('上传失败，请重新上传')
    },
    // 显示或隐藏
    showChange (value, item) {
      const result = value === 1
      item.show = result
    },
    // 字体大小改变事件
    fontSizeChange (value, item) {
      item.fontSize = value
    },
    // 字体改变事件
    fontWeightChange (value, item) {
      item.fontWeight = value
    },
    // 字体颜色
    changeColor (value, item) {
      console.log(value, item)
      item.colorStr = value.replace('#', '')
    },
    getColor (item) {
      return '#' + item.colorStr
    },
    // 弹出自定义证书内容弹窗
    addPrintData () {
      this.$refs.addPrintCertData.show()
    },
    // 删除某个元素
    del (index) {
      this.certData.splice(index, 1)
    },
    // 自定义证书内容添加成功回调，在这里创建证书打印元素并添加到打印信息元素中
    addPrintDataSuccess (args) {
      console.log(args)
      // this.$refs.addPrintCertData.handleSubmit()
      const dataTitle = args[0]
      const dataContent = args[1]
      this.certData.push(this.getDiv4Content(dataTitle, dataContent, true, this.certData))
    },

    handleChangeLogo ({ fileList }) {
      this.fileLogo = fileList
      if (fileList[0].response !== undefined) {
        this.backgroundImg = fileList[0].response.qiniuUrl
      }
    },
    removeImg () {
      this.imageUrl = ''
      this.backgroundImg = ''
    },
    // 移动证书内容元素
    moveContent (e, item) {
      // 获取目标元素
      var _target = e.target
      // 算出鼠标相对元素的位置
      var disX = e.clientX - _target.offsetLeft
      var disY = e.clientY - _target.offsetTop
      document.onmousemove = e => {
        // 鼠标按下并移动的事件
        // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX
        let top = e.clientY - disY
        if (top < 0) {
          top = 0
        }
        if (left < 0) {
          left = 0
        }
        // 绑定元素位置到positionX和positionY上面
        item.positionTop = top
        item.positionLeft = left

        // 移动当前元素
        _target.style.left = left + 'px'
        _target.style.top = top + 'px'
      }
      document.onmouseup = e => {
        document.onmousemove = null
        document.onmouseup = null
      }
    },
    downLoadPdf (htmlTitle, nowTime) {
      var params = {
        div4Width: this.div4Width,
        div4Height: this.div4Height,
        printName: this.rowData.userName + '-' + this.rowData.projectName + '-' + this.rowData.typeName,
        certData: this.certData
      }
      console.log(params, '------params')

      var url = '../../static/printCert.html?params=' + encodeURIComponent(JSON.stringify(params))
      window.open(url)
      // var url = '/printCert.html?params=' + JSON.stringify(params)
      // window.open('/#/printCert.html/?params=' + JSON.stringify(params))
    },
    // 查询模板内容
    queryTemplate (certId) {
      this.confirmLoading = true
      findById({memberId: this.assoUserInfo.memberId, certId: certId}).then(res => {
        this.confirmLoading = false
        console.log(res.data)
        if (res.data.status === 0) {
          const data = res.data.data
          if (data != null) {
            var dataJson = JSON.parse(data.template)
            // 根据返回模板内容重新定义长宽
            this.div4Width = dataJson.div4Width
            this.div4Height = dataJson.div4Height
            if (this.div4Width < this.div4Height) {
              this.templateModel = 1
            } else {
              this.templateModel = 2
            }
            const templateCertData = dataJson.certData
            for (var i = 0; i < templateCertData.length; i++) {
              const templateItem = templateCertData[i]
              // 获取模板内容是否是自定义的内容, 如果是自定义的内容，则将内容加入到显示内容中
              const isCustom = templateItem.isCustom

              if (isCustom) {
                const obj = {
                  name: templateItem.name,
                  value: templateItem.value,
                  // 每个元素距离顶部的距离递增30
                  positionTop: templateItem.positionTop,
                  positionLeft: templateItem.positionLeft,
                  fontSize: templateItem.fontSize,
                  fontWeight: templateItem.fontWeight,
                  show: templateItem.show,
                  isCustom: isCustom,
                  colorStr: templateItem.colorStr
                }
                this.certData.push(obj)
              } else {
                // 如果模板内容不是自定义的内容，则循环已创建的显示内容，重新指定相关属性
                this.certData.some(item => {
                  // 如果name相同，表示是同一条数据
                  if (item.name === templateItem.name) {
                    item.positionTop = templateItem.positionTop
                    item.positionLeft = templateItem.positionLeft
                    item.fontSize = templateItem.fontSize
                    item.fontWeight = templateItem.fontWeight
                    item.show = templateItem.show
                    item.colorStr = templateItem.colorStr
                    return true
                  }
                })
              }
            }
          }
        }
      }).catch(() => {
        this.confirmLoading = false
      })
    },
    // 保存模板
    saveTemplateFun () {
      // 复制一个定义的模板内容，将打印内容中的value值统一修改为name值
      var copyCertData = JSON.parse(JSON.stringify(this.certData))
      for (var i = 0; i < copyCertData.length; i++) {
        var item = copyCertData[i]
        item.value = item.name
      }
      var data = {
        div4Width: this.div4Width,
        div4Height: this.div4Height,
        certData: copyCertData
      }
      const templateStr = JSON.stringify(data)
      var params = {
        certId: this.rowData.certId,
        memberId: this.assoUserInfo.memberId,
        template: templateStr
      }
      this.confirmLoading = true
      saveTemplate(params).then(res => {
        this.confirmLoading = false
        console.log(res)
        if (res.data.status === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(() => {
        this.confirmLoading = false
        this.$message.error('服务器繁忙,模板保存失败')
      })
    },
    // 横竖屏切换，每次切换需要重置页面元素位置
    templageModelChange (value) {
      if (value === 1) {
        this.div4Width = 580
        this.div4Height = 820
      } else {
        this.div4Width = 820
        this.div4Height = 580
      }
      // 重置页面元素位置
      const ary = []
      this.certData.forEach(item => {
        const obj = this.getDiv4Content(item.name, item.value, item.isCustom, ary)
        ary.push(obj)
      })
      this.certData = ary
    },
    back () {
      this.$router.push({
        path: `/PersonInfo`,
        query: {
          flag: '3'
        }
      })
      // this.$router.push({name: 'PersonInfo ', params: { flag: 3 }})
    }
  }
}
</script>

<style  scoped>
.a4Div{
  float: left;
  overflow: hidden;
  border: 1px solid #cccccc;
  text-align: center;
  color: #999999;
  font-size: 14px;
  position: relative;
  margin-right: 20px;
}

.a4Div > span {
  font-size: 14px;
  overflow: hidden;
  position: absolute;
  cursor: pointer;
  color: #000;
}
.posiImg{
  width:150px;
  position: absolute;
  top: 260px;
  left: 400px;
}

.a4Option {
  float: left;
  overflow: hidden;
  width: 540px;
  border: 0px solid #cccccc;
  font-size: 14px;
  line-height: 40px;
}
.a4Option .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .a4Option .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .pdelete {
    position: absolute;
    width:30px;
    height: 30px;
    left: 50%;
    top:50%;
    margin-left: -15px;
    margin-top: -15px;
    z-index: 1;
    color: #fff;
    cursor: pointer;
  }
  .el-icon-delete:before{
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/PrintCert.vue